import { useEffect, useState } from "react";
import { setSimulateurObject } from "../../../actions/simulateur.action";
import { useDispatch } from "react-redux";
import { styles } from "../../../stylesheets/simulateurs.css";
import "../../../stylesheets/simulateursBis.css";
import TextSimulateurTitle from "../../../components/texts/text.simulateurTitle";
import TextfieldNumber from "../../../components/textfields/textfield.number";
import SelectDepartement from "../../../components/selects/select.departement";
import ButtonYesno from "../../../components/buttons/button.yesno";
import DmtgMain from "../../dmtg/DmtgMain";
import TextfieldRemarques from "../../../components/textfields/textfiel.remarques";
import BadgeNouveau from "../../../components/texts/BadgeNouveau";
import { ToolTipPerso } from "../../../components/selects/tooltip_perso";
import { Typography } from "@mui/material";
import TextfieldAbattement from "../../../components/textfields/textfield.abattement";
import SelectCommon from "../../../components/selects/select.common";
import DeboursQuestion from "../../../components/questions/DeboursQuestion";
import ConventionHonoraires from "../../../components/questions/ConventionHonoraires";

// Déclarations de successions
// Id simulateur 52, A2-12
// simulateurs associés : dmtg succession

function Simulateur_52(props) {
  const dispatch = useDispatch();

  let currUser = JSON.parse(localStorage.getItem("user"));
  let currUserDep;
  if (currUser.societe_zip.startsWith("97")) {
    let trimedZip;
    trimedZip = currUser.societe_zip.slice(0, 3);
    currUserDep = parseInt(trimedZip);
  } else {
    let trimedZip;
    trimedZip = currUser.societe_zip.slice(0, 2);
    currUserDep = parseInt(trimedZip) || 1;
  }

  const [simulateurForDMTG, setSimulateurForDMTG] = useState({
    id: 55,
    name: "DMTG - Succession 1 à 9 personnes",
  });

  const [departement, setDepartement] = useState(0);
  const [montant_succession, setSuccession] = useState(0);
  const [choix_meubles, setChoixMeubles] = useState(1);
  const [valeur_meubles, setValeurMeubles] = useState(0);
  const [montant_article757b, setMontantArticle757b] = useState(0);
  const [donations_rapportables, setDonationsRapportables] = useState(0);
  const [DMTG, setDMTG] = useState(0);
  const [conjointSurvivantDMTG, setConjointSurvivantDMTG] = useState(false);
  const [responseDMTG, setResponseDMTG] = useState(null);
  const [montantDeboursAdditionnels, setMontantDeboursAdditionnels] = useState(0);
  const [deboursAdditionnels, setDeboursAdditionnels] = useState(0);

  const choixMeubles = [
    { id: 1, name: "Forfait mobilier (5% de l'actif brut)" },
    { id: 2, name: "Valeur déterminée selon inventaire" },
  ];

  useEffect(() => {
    if (parseInt(choix_meubles) !== 1) return;

    const valeurForfaitaire = parseInt(montant_succession || 0) * 0.05;
    setValeurMeubles(valeurForfaitaire);
  }, [montant_succession, choix_meubles]);

  const handleChange = async (setter, value, key) => {
    if (setter === setDepartement) {
      setDepartement(parseInt(value));
    } else if (setter === setChoixMeubles) {
      const choixMeublesValue = parseInt(value);
      setChoixMeubles(choixMeublesValue);
      setValeurMeubles(choixMeublesValue === 1 ? parseInt(montant_succession || 0) * 0.05 : 0);
    } else {
      setter(value);
    }
    setInRedux(setter, value, key);
  };

  const handleChangeRemarque = async (value) => {
    localStorage.setItem("remarque", value);
  };

  function setInRedux(setter, value, key) {
    if (props.isParent) {
      let object = {
        simulateurid: props.simulateur.id,
        departementid: parseInt(departement),
        inputs: {
          montant_succession: parseInt(montant_succession),
          choix_meubles: parseInt(choix_meubles),
          valeur_meubles: parseInt(valeur_meubles),
          montant_article757b: parseInt(montant_article757b),
          donations_rapportables: parseInt(donations_rapportables),
          DMTG: parseInt(DMTG),
          montant_deb_add: parseInt(montantDeboursAdditionnels),
          debours_additionnels: parseInt(deboursAdditionnels),
          convention_honoraires : parseInt(props.conventionHonoraires),
        },
        pdfInputs: {
          nombre_convention_honoraires : parseInt(props.nombreConventionHonoraires),
          object_convention_honoraires : props.objectConventionHonoraires,
          montant_convention_honoraires : parseInt(props.montantConventionHonoraires),
          nom_signataire_convention_honoraires : props.nomSignataireConventionHonoraires,
          adresse_signataire_convention_honoraires : props.adresseSignataireConventionHonoraires,
        },
        DMTG: responseDMTG,
      };
       //For values coming from components
      if (key) {
        if (key === "debours_additionnels") {
          if (value === 0) {
            setMontantDeboursAdditionnels(0)
            Object.assign(object["inputs"], { montant_deb_add: parseInt(0) });
          }
          Object.assign(object["inputs"], { debours_additionnels: parseInt(value) });
        }
        if (key === "montant_deb_add") { Object.assign(object["inputs"], { montant_deb_add: parseInt(value) }); }
      }
      //For internal settings
      if (setter === setDepartement) { object.departementid = parseInt(value); }
      if (setter === setSuccession) { Object.assign(object.inputs, { montant_succession: parseInt(value),
          valeur_meubles: parseInt(choix_meubles) === 1 ? parseInt(value || 0) * 0.05 : parseInt(valeur_meubles),
        });
      }
      if (setter === setChoixMeubles) {
        const choixMeublesValue = parseInt(value);
        Object.assign(object.inputs, {
          choix_meubles: choixMeublesValue,
          valeur_meubles: choixMeublesValue === 1 ? parseInt(montant_succession || 0) * 0.05 : 0,
        });
      }
      if (setter === setValeurMeubles) { Object.assign(object.inputs, { valeur_meubles: parseInt(value) }); }
      if (setter === setMontantArticle757b) { Object.assign(object.inputs, { montant_article757b: parseInt(value) }); }
      if (setter === setDonationsRapportables) { Object.assign(object.inputs, { donations_rapportables: parseInt(value) }); }
    
      if (setter === setDMTG) {
        if (value === 0) {
          setConjointSurvivantDMTG(false);
          setResponseDMTG([]);
          Object.assign(object.inputs, { DMTG: parseInt(value) });
          object.DMTG = [];
        } else {
          Object.assign(object.inputs, { DMTG: parseInt(value) });
        }
      }

      if (setter === setResponseDMTG) {
        Object.assign(object.inputs, { result: 1, });
        object.DMTG = value;
      }

      if (setter === props.setConventionHonoraires) {
        if(value === 0){
          props.setNombreConventionHonoraires(1);
          props.setObjectConventionHonoraires(null);
          props.setMontantConventionHonoraires(null);
          props.setNomSignataireConventionHonoraires(null);
          props.setAdresseSignataireConventionHonoraires(null);
          Object.assign(
            object["inputs"], { convention_honoraires : parseInt(value) },
            object["pdfInputs"], {
              nombre_convention_honoraires : null,
              object_convention_honoraires : null,
              montant_convention_honoraires : null,
              nom_signataire_convention_honoraires : null,
              adresse_signataire_convention_honoraires : null
            },
          );
        } else {
          Object.assign(object["inputs"], { convention_honoraires : parseInt(value) });
        }
      }
      if (setter === props.setNombreConventionHonoraires) { Object.assign(object.pdfInputs, { nombre_convention_honoraires: parseInt(value) }); }
      if (setter === props.setObjectConventionHonoraires) { Object.assign(object.pdfInputs, { object_convention_honoraires: value }); }
      if (setter === props.setMontantConventionHonoraires) { Object.assign(object.pdfInputs, { montant_convention_honoraires: parseInt(value) }); }
      if (setter === props.setNomSignataireConventionHonoraires) { Object.assign(object.pdfInputs, { nom_signataire_convention_honoraires: value }); }
      if (setter === props.setAdresseSignataireConventionHonoraires) { Object.assign(object.pdfInputs, { adresse_signataire_convention_honoraires: value }); }

      dispatch(setSimulateurObject(object));
    } else {
      // process child simu
    }
  }

  return (
    <div style={styles.container}>
      <div className="cardSimulateur">
        <TextSimulateurTitle 
          title={"Déclaration de succession (Émoluments de DS et calcul de DMTG 1er et 2e décès)"} 
          currentSimuId={props.simulateur.id} 
        />

        <TextfieldRemarques handleChange={handleChangeRemarque} />

        <p style={styles.cardSubTitle}>Acte tarifé au titre du Tableau 5, n° 8 (Art A444-63)</p>

        {props?.isParent === true && props.departements !== "" ? (
          <div className="cardRow">
            <div style={styles.cardElemVerticalyCenter}>Département :</div>

            <SelectDepartement
              items={props.departements}
              nameField={"name"}
              defaultValue={currUserDep}
              optionValue={"id"}
              handleChange={handleChange}
              setter={setDepartement}
            />
          </div>
        ) : (
          <></>
        )}
        {/*MONTANT A*/}
        <div className="cardRow">
          <div style={styles.cardElemVerticalyCenter}>
            Actif brut de succession :
            <ToolTipPerso
              title={
                "Pour le calcul de l’émolument, l’assiette a pour base l’actif brut total, en ce compris s’il y a communauté, participation ou société d’acquêts, les biens qui en dépendent (C. com., art. A. 444-63, Tableau 5, n° 8)."
              }
            />
          </div>
          <TextfieldNumber
            handleChange={handleChange}
            type={"number"}
            placeholder={"Indiquer le montant"}
            setter={setSuccession}
          />
        </div>

        {!(parseInt(DMTG) === 1 && conjointSurvivantDMTG) ? (
          <>
            <div className="cardRow">
              <div style={styles.cardElemVerticalyCenter}>
                Meubles meublants :
                <ToolTipPerso
                  title={
                    "Seul le forfait mobilier correspondant à 5 % de l'actif brut de succession est inclus dans l'assiette de l'émolument. Si les meubles ont fait l'objet d'une prisée donnant lieu à la perception d'un émolument par le notaire, aucun émolument ne peut être perçu sur la partie de l'actif brut correspondant à la valeur prisée de ces meubles (C. com., art. A. 444-63)."
                  }
                />
              </div>
              <SelectCommon
                items={choixMeubles}
                defaultValue={choix_meubles}
                nameField={"name"}
                optionValue={"id"}
                handleChange={handleChange}
                setter={setChoixMeubles}
              />
            </div>

            <div className="cardRow">
              <div style={styles.cardElemVerticalyCenter}>Valeur des meubles meublants :</div>
              {parseInt(choix_meubles) === 2 ? (
                <TextfieldNumber
                  handleChange={handleChange}
                  type={"number"}
                  placeholder={"Indiquer le montant"}
                  setter={setValeurMeubles}
                />
              ) : (
                <TextfieldAbattement
                  type={"number"}
                  placeholder={`${valeur_meubles.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ")} €`}
                />
              )}
            </div>
          </>
        ) : null}

        <div className="cardRow">
          <div style={styles.cardElemVerticalyCenter}>
            Primes taxables au titre de l’article 757B du CGI :
            <ToolTipPerso
              title={
                "Total des primes versées sur le ou les contrats d’assurance-vie après le 70e anniversaire de l’assuré, après application de l’abattement de 30 500 € applicable à la somme totale de la prime."
              }
            />
          </div>
          <TextfieldNumber
            handleChange={handleChange}
            type={"number"}
            placeholder={"Indiquer le montant"}
            setter={setMontantArticle757b}
          />
        </div>

        <div className="cardRow">
          <div style={styles.cardElemVerticalyCenter}>
            Montant total des donations rapportables, qu'elles aient plus ou moins de 15 ans :
            <ToolTipPerso
              title={
                "S’il y a des donations antérieures, seules les donations rapportables au sens civil sont à inclure dans l’assiette de l’émolument proportionnel pour leur valeur rapportable au jour du décès, quelle que soit leur ancienneté."
              }
            />
          </div>
          <TextfieldNumber
            handleChange={handleChange}
            type={"number"}
            placeholder={"Indiquer le montant"}
            setter={setDonationsRapportables}
          />
        </div>

        <DeboursQuestion
          handleChange={handleChange}
          deboursAdditionnels={deboursAdditionnels}
          setDeboursAdditionnels={setDeboursAdditionnels}
          setMontantDeboursAdditionnels={setMontantDeboursAdditionnels}
        />
        
        <ConventionHonoraires
          handleChange={handleChange}
          conventionHonoraires={props.conventionHonoraires}
          setConventionHonoraires={props.setConventionHonoraires}
          nombreConventionHonoraires={props.nombreConventionHonoraires}
          setNombreConventionHonoraires={props.setNombreConventionHonoraires}
          objectConventionHonoraires={props.objectConventionHonoraires}
          setObjectConventionHonoraires={props.setObjectConventionHonoraires}
          montantConventionHonoraires={props.montantConventionHonoraires}
          setMontantConventionHonoraires={props.setMontantConventionHonoraires}
          nomSignataireConventionHonoraires={props.nomSignataireConventionHonoraires}
          setNomSignataireConventionHonoraires={props.setNomSignataireConventionHonoraires}
          adresseSignataireConventionHonoraires={props.adresseSignataireConventionHonoraires}
          setAdresseSignataireConventionHonoraires={props.setAdresseSignataireConventionHonoraires}
        />
        <div className="cardRow">
          <div style={styles.cardElemVerticalyCenter}>
            Souhaitez-vous faire le calcul des DMTG ?
            <BadgeNouveau cliquable={false} />
          </div>
          <div>
            <ButtonYesno handleChange={handleChange} setter={setDMTG} fieldUndefined={false} defaultValue={0} />
          </div>
        </div>

        {DMTG ? (
          <DmtgMain
            callSinceSimu={true}
            simulateur={simulateurForDMTG}
            setter={setResponseDMTG}
            handleChange={handleChange}
            calculateDMTGState={props.calculateDMTGState}
            montant_brut={montant_succession}
            choix_meubles={choix_meubles}
            valeur_meubles={valeur_meubles}
            donations_rapportables={donations_rapportables}
            onConjointSurvivantChange={setConjointSurvivantDMTG}
          />
        ) : (
          <></>
        )}
      </div>
    </div>
  );
}

export default Simulateur_52;
